import {
  IAchievementWithProgress,
  IClosestAchievement,
  IGamificationSummary,
  INewlyCompleted,
} from 'modules/core/types/gamification';

import { RootState } from '../store';
import { GamificationState } from '../reducers/gamification.reducer';

export const getGamificationState = (state: RootState): GamificationState => state.gamification;

export const getGamificationSummary = (state: RootState): IGamificationSummary | null =>
  getGamificationState(state).summary;

export const getAchievements = (state: RootState): IAchievementWithProgress[] =>
  getGamificationState(state).achievements;

export const getNewlyCompleted = (state: RootState): INewlyCompleted[] => getGamificationState(state).newlyCompleted;

export const getGamificationLoading = (state: RootState): boolean => getGamificationState(state).loading;

export const getHasFetchedAchievements = (state: RootState): boolean =>
  getGamificationState(state).hasFetchedAchievements;

export const getClosestAchievement = (state: RootState): IClosestAchievement | null =>
  getGamificationState(state).summary?.closest_achievement ?? null;

export const getHasTrackedSearch = (state: RootState, source: string): boolean =>
  getGamificationState(state).trackedSearchSources[source] ?? false;
